import { api } from './api';

export const inventoryApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getInventoryOrder: builder.mutation({
      query: ({
        order,
        orderBy,
        filterKey,
        filter,
        headerFilters,
        inventoryOrderId,
        inventoryOrderIndex,
        dateRange,
      }) => {
        return {
          url: 'getInventoryOrder',
          method: 'POST',
          body: {
            order,
            orderBy,
            filterKey,
            filter,
            headerFilters,
            inventoryOrderId,
            inventoryOrderIndex,
            dateRange,
          },
        };
      },
    }),

    getInventoryOrders: builder.query({
      query: ({
        order,
        orderBy,
        filterKey,
        filter,
        headerFilters,
        pageIndex,
        pageSize,
        dateRange,
      }) => {
        return {
          url: 'getInventoryOrders',
          method: 'POST',
          body: {
            order,
            orderBy,
            filter,
            filterKey,
            headerFilters,
            page: pageIndex,
            pageSize,
            dateRange,
          },
        };
      },
    }),

    updateInventoryOrder: builder.mutation({
      query: ({ inventoryOrderId, diffs }) => {
        return {
          url: 'updateInventoryOrder',
          method: 'POST',
          body: {
            inventoryOrderId,
            diffs,
          },
        };
      },
    }),

    getInventoryReport: builder.mutation({
      query: ({
        order,
        orderBy,
        collections,
        page,
        pageSize,
        showInProduction,
      }) => {
        return {
          url: 'getInventoryReport',
          method: 'POST',
          body: {
            order,
            orderBy,
            collections,
            page,
            pageSize,
            showInProduction,
          },
        };
      },
    }),

    getInventorySalesReport: builder.mutation({
      query: ({
        order,
        orderBy,
        collections,
        page,
        pageSize,
        dateFrom,
        dateTo,
      }) => {
        return {
          url: 'getInventorySalesReport',
          method: 'POST',
          body: {
            order,
            orderBy,
            collections,
            page,
            pageSize,
            dateFrom,
            dateTo,
          },
        };
      },
    }),

    receiveAllInventoryItems: builder.mutation({
      query: ({ inventoryOrderId, barcodes }) => {
        return {
          url: 'receiveAllInventoryItems',
          method: 'POST',
          body: {
            inventoryOrderId,
            barcodes,
          },
        };
      },
    }),

    getInventoryAnalytics: builder.mutation({
      query: ({
        collections,
        timePeriodDays,
        page,
        pageSize,
        order,
        orderBy,
        tileFilterField,
        tileFilterValue,
      }) => {
        return {
          url: 'getInventoryAnalytics',
          method: 'POST',
          body: {
            collections,
            timePeriodDays,
            page,
            pageSize,
            order,
            orderBy,
            tileFilterField,
            tileFilterValue,
          },
        };
      },
    }),

  }),
});

export const {
  useGetInventoryOrderMutation,
  useGetInventoryOrdersQuery,
  useGetInventoryReportMutation,
  useGetInventorySalesReportMutation,
  useUpdateInventoryOrderMutation,
  useReceiveAllInventoryItemsMutation,
  useGetInventoryAnalyticsMutation,
} = inventoryApi;
